import React from 'react';
import PropTypes from 'prop-types';
import { ChipField as RAChipField, useRecordContext } from 'react-admin';

const smallSx = {
	height: '20px'
}

const ChipField = ({ source, color = 'default', size = 'small', ...props }) => {
	const record = useRecordContext(props);

	return (
		record && (record[source] !== undefined && record[source] !== null) ? 
			<RAChipField sx={size === 'small' ? smallSx : ''} {...{ record, source, size, color, ...props }} /> 
		: null
	);
};

ChipField.propTypes = {
	source: PropTypes.string.isRequired,
	size: PropTypes.oneOf(["small", "medium"]),
	color: PropTypes.string
};

export default ChipField;